enum Paths {
  Root = "/subscription",
  Overview = "overview",
  Billing = "billing",
}

export default Paths;
